import { DandelionSeed } from "@/components/DandelionSeed";

export default function Motivation() {
  return (
    <section
      id="motivation"
      data-testid="motivation-section"
      className="relative py-24 lg:py-32"
    >
      <div className="max-w-5xl mx-auto px-6 lg:px-10">
        <div className="text-center">
          <p className="eyebrow reveal justify-center" style={{ display: "inline-flex" }}>
            Meine Motivation
          </p>
          <h2
            className="font-display text-4xl sm:text-5xl lg:text-6xl mt-6 reveal reveal-delay-1"
            style={{ color: "var(--ink)" }}
          >
            Wachstum ist möglich —
            <br />
            <em className="font-serif italic" style={{ color: "var(--sky-deep)" }}>
              bis ins hohe Alter
            </em>
            .
          </h2>
        </div>

        <div
          className="mt-14 mx-auto max-w-3xl text-center reveal reveal-delay-2"
          data-testid="motivation-quote"
        >
          <p
            className="font-serif italic text-2xl sm:text-3xl leading-snug"
            style={{ color: "var(--ink)" }}
          >
            Wenn jemand den Wunsch nach Veränderung hat und aktiv daran arbeitet, bilden sich
            neue Verbindungen in den neuronalen Netzwerken unseres Gehirns. Dies fördert
            Wachstum, Veränderung und Neuorientierung bis ins hohe Alter.
          </p>

          <div
            className="mt-10 inline-flex items-center gap-3"
            style={{ color: "var(--ink-mute)" }}
          >
            <DandelionSeed size={22} />
            <span className="text-xs tracking-[0.24em] uppercase">
              Petra Fellmann · Praxis Seelen-Raum
            </span>
            <DandelionSeed size={22} />
          </div>
        </div>
      </div>
    </section>
  );
}
